var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wauchat"},[_c('b-link',{attrs:{"href":_vm.urlWhatapp+_vm.phone,"target":"_blank"}},[_c('b-img',{staticClass:"socialIcondiv--icon",attrs:{"src":require("@/assets/whatsapp.svg"),"width":"20px;"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }